import React from "react";
import { connect } from "react-redux";
import { toggleMobileNavVisibility } from "../../reducers/Layout";
import { Navbar, Nav, MenuItem, DropdownButton } from "react-bootstrap";
import * as GlobalFunc from "../../utils/globalFunc";
import LogoutIcon from "../../assets/icons/log_out.png";

const downloadURI = (uri, name) => {
  const link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
};

const langList = { vn: "Vietnamese", en: "English" };

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLang: "vn", // default language
    };
  }

  setSelectedLang = (lang) => {
    this.setState({ selectedLang: lang });
  };
  render() {
    const { showMobileMenu, toggleMobileNavVisibility } = this.props;
    const { selectedLang } = this.state;
    return (
      <Navbar fluid={true}>
        <Navbar.Header>
          <button
            type="button"
            className="navbar-toggle"
            data-toggle="collapse"
            onClick={toggleMobileNavVisibility}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav
            pullRight
            style={{ display: "flex", alignItems: "center", gap: 10 }}
            className="collapse-container"
          >
            <DropdownButton
              title={langList[selectedLang]}
              bsSize="small"
              block="true"
              className="dropdown-lang"
            >
              <MenuItem onSelect={() => this.setSelectedLang("vn")}>
                Vietnamese
              </MenuItem>
              <MenuItem onSelect={() => this.setSelectedLang("en")}>
                English
              </MenuItem>
            </DropdownButton>
            <a
              rel="tooltip"
              aria-disabled="true"
              className="btn btn-info btn-simple btn-xs"
              data-original-title="Log out"
              onClick={() => {
                GlobalFunc.logout();
              }}
              style={{ padding: 12 }}
            >
              <span
                style={{
                  color: "#303030",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: 1,
                }}
              >
                Log out
              </span>
              <img
                src={LogoutIcon}
                alt="log out"
                style={{ width: 16, height: 16, marginLeft: 8 }}
              />
            </a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapDispatchToProp = (dispatch) => ({
  toggleMobileNavVisibility: () => dispatch(toggleMobileNavVisibility()),
});

export default connect(null, mapDispatchToProp)(Header);



// WEBPACK FOOTER //
// ./src/pages/Main/Header.js